<template>
    <div :class="`tate ${optionalClass}`">
        <span>{{text}}</span>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
export default Vue.extend({
    props:{
        text:{
            type:String,
            default:()=>{
                return ''
            }
        },
        optionalClass:{
            type:String,
            default:()=>{
                return ''
            }
        },
    }
    
})
</script>

<style>
.tate{
    margin: 2rem 2rem 0rem 0.25rem;
    writing-mode: vertical-rl;
}

@media screen and (max-width:550px){
    .tate{
    margin: 2rem 0.25rem;
}
}

</style>